// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2X7zQGmkcQNrmDAjYXKNwQ","Footer":"sJ-JjFaoXtqujKzFB_tsS","MenuItem":"_3262o_IuKc9YJ9mwjb87CF","Header":"_2LVy4TqR5c8Hz6y6QgGqxD","Title":"_2G5Ggg8BDsjpUy8-fXISy2","TableWrap":"KbvdVX37UxqVhY_2p5fAH","PaginationWrap":"pSh6QChgrvD1E5Z4Y4XJ0","ActiveLink":"_3ydrSOXB0o8t_uqwOsW6cm","MainColumn":"_3hVgSbgzBQkONfumOAhzRv","SideColumn":"_1nBgC5uiATIQ-ASW4-Nfqx","StackOnMobile":"_3dyXmc8-EEj2IhCWITYwtz","container-fluid":"_14tHgMulJyTzEB_N5r1Je5"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Metal/PcaList/styles.module.css
// module id = 635
// module chunks = 0